import {Hydra} from '../generic/hydra';

import {DisciplineTranslationInterface} from './DisciplineTranslation';
import {CommissionInterface} from './Commission';
import {Discipline as DisciplineBaseInterface} from '../../interface/api/Discipline';

export type DisciplineInterface = DisciplineBaseInterface;

export class Discipline extends Hydra implements DisciplineInterface {

    id?: number | null;

    translations?: DisciplineTranslationInterface[] | null;

    idMicroscopie?: number | null;

    parent?: any | null;

    children?: any[] | null = [];

    commission?: CommissionInterface|string | null;

    position?: number | null;


    constructor(options: DisciplineInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
